import { Action } from 'redux';

import { SetTabsWorkbook } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface SetTabsWorkbookAction extends Action {
  workbooks: IContentInfo[];
}

export function setTabs(workbooks: IContentInfo[]): SetTabsWorkbookAction {
  return {
    type: SetTabsWorkbook,
    workbooks
  };
}

const isSetTabsWorkbookAction = isActionFactory<SetTabsWorkbookAction>(SetTabsWorkbook);
